import BackboneEvents from 'backbone-events-standalone';
import mixin from './mixin';

export const decorator = mixin(BackboneEvents);
export const withEvents = Component => decorator(Component);
